module.exports = __webpack_public_path__ + "img/h2o.2e7f0371.svg";